import { useState } from 'react';
import analytics from '../../segmentTracking';

const {
  Popover,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Flex,
  Switch,
  Box,
  Text,
} = require('@chakra-ui/react');
const CustomizeTablePopup = ({
  visibleColumns,
  setVisibleColumns,
  isOpen,
  onClose,
}) => {
  const [currentUser] = useState(JSON.parse(localStorage.getItem('user')));

  // Function to toggle column visibility
  const toggleColumnVisibility = (column) => {
    // Prevent instructors from toggling the instructors column
    if (
      column === 'instructors' &&
      currentUser?.role?.toLowerCase() === 'instructor'
    ) {
      return;
    }

    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
    // Track column visibility
    analytics.track(`people:customizetable:options:toggled`, {
      email: currentUser.email,
      userRole: currentUser?.role,
      column: column,
    });
  };

  // Get available columns based on user role
  const getAvailableColumns = () => {
    const userRole = currentUser?.role?.toLowerCase();

    if (userRole === 'super_admin') {
      return [
        // Always visible columns first
        'name', // Full Name
        'username', // Username
        'email', // Email
        'status', // Status
        'id', // Twella ID
        'ipLocation', // IP Location
        'subscriber', // Subscription
        'lastActivityTime', // Last Activity
        // Hidden by default columns last (when unhidden, they appear at the end)
        'age',
        'gender',
        'race',
        'lastSessions',
        'totalSessions',
        'politicalPreferences',
        'schools',
        'courses',
        'classes',
        'instructors',
      ];
    } else {
      return [
        // Always visible columns first
        'name', // Full Name
        'username', // Username
        'email', // Email
        'status', // Status
        'lastActivityTime', // Last Activity
        // Hidden by default columns last (when unhidden, they appear at the end)
        'age',
        'gender',
        'race',
        'lastSessions',
        'totalSessions',
        'schools',
        'courses',
        'classes',
        // Instructors column is always hidden for instructor role users
        ...(userRole !== 'instructor' ? ['instructors'] : []),
      ];
    }
  };

  const columnNames = getAvailableColumns();

  // Get display names for columns
  const getColumnDisplayName = (column) => {
    const displayNames = {
      name: 'Full Name',
      username: 'Username',
      email: 'Email',
      status: 'Status',
      id: 'Twella ID',
      ipLocation: 'IP Location',
      subscriber: 'Subscription',
      lastActivityTime: 'Last Activity',
      lastSessions: 'Last Session',
      totalSessions: 'Total Sessions',
      age: 'Age',
      gender: 'Gender',
      race: 'Race',
      politicalPreferences: 'Political Preferences',
      schools: 'Schools',
      courses: 'Courses',
      classes: 'Classes',
      instructors: 'Instructors',
    };
    return (
      displayNames[column] || column.charAt(0).toUpperCase() + column.slice(1)
    );
  };

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="left-start">
      <PopoverContent
        width="217px"
        position="absolute"
        // right="calc(0% + -190px)"
        right="calc(0% + -50px)"
        top="50px"
        borderColor={'#EF6506'}
        borderWidth={'1px'}
      >
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader fontSize={'14px'} fontWeight={'500'} color={'#222222'}>
          Table options
        </PopoverHeader>
        <PopoverBody>
          <Flex justifyContent="space-between" alignItems="center" mb={2}>
            <Text fontSize={'12px'} fontWeight={'500'} color={'#676666'}>
              COLUMNS
            </Text>
            <Text fontSize={'12px'} fontWeight={'500'} color={'#676666'}>
              HIDE/SHOW
            </Text>
          </Flex>
          {columnNames.map((column) => (
            <Box
              key={column}
              display="flex"
              alignItems="center"
              mb="2"
              justifyContent={'space-between'}
            >
              <Text fontSize={'14px'} fontWeight={'400'} color={'#222222'}>
                {getColumnDisplayName(column)}
              </Text>
              <Switch
                id={column}
                isChecked={visibleColumns[column]}
                onChange={() => toggleColumnVisibility(column)}
                mr="2"
                sx={{
                  '& .chakra-switch__track': {
                    backgroundColor: '#C2C2C2',
                  },
                  '& .chakra-switch__track[data-checked]': {
                    backgroundColor: '#EF6506',
                  },
                }}
              />
            </Box>
          ))}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default CustomizeTablePopup;
